import Mock from './mock';

import './db/notification';

Mock.onAny().passThrough();
